'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalDrink = function MdLocalDrink(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.5 13.4l0.8-6.8h-22.5l0.7 6.8h21z m-10.5 18.2c2.7 0 5-2.2 5-5 0-3.3-5-8.9-5-8.9s-5 5.6-5 8.9c0 2.8 2.3 5 5 5z m-15-28.2h30l-3.4 30.4c-0.2 1.6-1.5 2.8-3.2 2.8h-16.8c-1.7 0-3-1.2-3.2-2.8z' })
        )
    );
};

exports.default = MdLocalDrink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-drink.js
// module id = 1630
// module chunks = 168707334958949